import React, { useEffect, useState } from "react";
import { subscribeLoading } from "../common/http/loading-tracker";

// Thin animated bar at the top of the window while any API request is in flight.
// Waits 150 ms before showing so instant responses don't flash.
const GlobalLoadingBar = () => {
  const [active, setActive] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeLoading((count) => setActive(count > 0)), []);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return undefined;
    }
    const id = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(id);
  }, [active]);

  if (!visible) return null;
  return <div className="global-loading-bar" role="progressbar" aria-label="Loading" />;
};

export default GlobalLoadingBar;
